export const loginAr = {
  adminLogin: "دخول المدير",
  teacherLogin: "دخول الأستاذ", 
  parentLogin: "دخول ولي الأمر",
  adminTitle: "النظام التعليمي",
  adminSubtitle: "تسجيل دخول المدير",
  associationName: "جمعية الفلاح",
  adminWarning: "هذه المنطقة مخصصة للمديرين فقط. يرجى التأكد من هويتك قبل المتابعة.",
  adminWelcome: "مرحباً بك في منصة المديرين - إدارة شاملة للنظام التعليمي",
  adminPlatform: "منصة المديرين",
  adminDescription: "إدارة شاملة لجميع جوانب النظام التعليمي ومتابعة الأداء",
  adminServices: "خدمات متاحة للمديرين:",
  adminService1: "إدارة الطلاب والمعلمين",
  adminService2: "إدارة الدرجات والتقييمات",
  adminService3: "إدارة التواصل والتقارير",
  adminService4: "إعدادات النظام والإحصائيات",
  teacherTitle: "النظام التعليمي",
  teacherSubtitle: "تسجيل دخول المعلم",
  teacherWelcome: "مرحباً بك في منصة المعلمين - إدارة ومتابعة طلابك في حفظ القرآن الكريم",
  teacherPlatform: "منصة المعلمين",
  teacherDescription: "إدارة ومتابعة طلابك في حفظ القرآن الكريم وتقييم أدائهم",
  teacherServices: "خدمات متاحة للمعلمين:",
  teacherService1: "تسجيل متابعة حفظ القرآن",
  teacherService2: "تسجيل الدرجات والتقييمات",
  teacherService3: "التواصل مع أولياء الأمور",
  teacherService4: "عرض التقارير والإحصائيات",
  parentTitle: "النظام التعليمي",
  parentSubtitle: "تسجيل دخول ولي الأمر",
  parentWelcome: "مرحباً بك في منصة أولياء الأمور - تابع تقدم أبنائك في حفظ القرآن الكريم",
  parentPlatform: "منصة أولياء الأمور",
  parentDescription: "تابع تقدم أبنائك في حفظ القرآن الكريم ومتابعة أدائهم ",
  parentServices: "خدمات متاحة لأولياء الأمور:",
  parentService1: "متابعة تقدم الطالب في الحفظ",
  parentService2: "عرض الدرجات والتقييمات", 
  parentService3: "التواصل مع المعلمين",
  parentService4: "استلام التقارير الشهرية",
  email: "البريد الإلكتروني",
  username: "اسم المستخدم",
  password: "كلمة المرور",
  rememberMe: "تذكرني",
  forgotPassword: "نسيت كلمة المرور؟",
  login: "تسجيل الدخول",
  loading: "جاري تسجيل الدخول...",
  noAccount: "ليس لديك حساب؟ انشاء حساب جديد",
  backHome: "العودة للصفحة الرئيسية",
  adminRequest: "طلب صلاحيات إدارية",
  enterUsername: "أدخل اسم المستخدم",
  enterPassword: "أدخل كلمة المرور",
  fillAllFields: "يرجى ملء جميع الحقول",
  loginError: "خطأ في تسجيل الدخول",
  connectionError: "خطأ في الاتصال بالخادم",
  enterUsernamePassword: "يرجى إدخال اسم المستخدم وكلمة المرور",
  serverError: "حدث خطأ أثناء التحقق من البيانات",
  maintenanceTitle: "الموقع قيد الإنشاء",
  maintenanceMessage: "نعمل حالياً على تطوير وتحسين الموقع. سيتم إطلاقه قريباً بإذن الله",
  forStaffAndAdmins: "للموظفين والمسؤولين",
  forStaffAndAdminsOnly: "للموظفين والمسؤولين فقط",
  resetSession: "إعادة تعيين الجلسة",
  noAccess: "ليس لديك صلاحية للوصول إلى هذه الصفحة. نوع المستخدم",
  unknown: "",
  or: "أو",
  forgotPasswordDescription: "أدخل البريد الإلكتروني أو اسم المستخدم أو رقم الهاتف لإعادة إرسال معلومات تسجيل الدخول",
  optional: "اختياري",
  enterEmail: "أدخل البريد الإلكتروني",
  enterPhone: "أدخل رقم الهاتف",
  phone: "رقم الهاتف",
  cancel: "إلغاء",
  send: "إرسال",
  forgotPasswordError: "يرجى إدخال البريد الإلكتروني أو اسم المستخدم أو رقم الهاتف",
  forgotPasswordSuccess: "تم إرسال معلومات تسجيل الدخول إلى بريدك الإلكتروني"
};

